"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDealRequestToJSON = exports.UpdateDealRequestFromJSONTyped = exports.UpdateDealRequestFromJSON = exports.instanceOfUpdateDealRequest = void 0;
var runtime_1 = require("../runtime");
var DealAdFormats_1 = require("./DealAdFormats");
var DealPlacements_1 = require("./DealPlacements");
var FrequencyCap_1 = require("./FrequencyCap");
var Targets_1 = require("./Targets");
/**
 * Check if a given object implements the UpdateDealRequest interface.
 */
function instanceOfUpdateDealRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "adFormats" in value;
    isInstance = isInstance && "placements" in value;
    isInstance = isInstance && "priceFloorMicroAmount" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "startTime" in value;
    isInstance = isInstance && "endTime" in value;
    isInstance = isInstance && "targets" in value;
    return isInstance;
}
exports.instanceOfUpdateDealRequest = instanceOfUpdateDealRequest;
function UpdateDealRequestFromJSON(json) {
    return UpdateDealRequestFromJSONTyped(json, false);
}
exports.UpdateDealRequestFromJSON = UpdateDealRequestFromJSON;
function UpdateDealRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'adFormats': (json['ad_formats'].map(DealAdFormats_1.DealAdFormatsFromJSON)),
        'placements': (json['placements'].map(DealPlacements_1.DealPlacementsFromJSON)),
        'priceFloorMicroAmount': json['price_floor_micro_amount'],
        'budgetMicroAmount': !(0, runtime_1.exists)(json, 'budget_micro_amount') ? undefined : json['budget_micro_amount'],
        'currencyCode': json['currency_code'],
        'startTime': (new Date(json['start_time'])),
        'endTime': (new Date(json['end_time'])),
        'targets': (0, Targets_1.TargetsFromJSON)(json['targets']),
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'frequencyCaps': !(0, runtime_1.exists)(json, 'frequency_caps') ? undefined : (new Set(json['frequency_caps'].map(FrequencyCap_1.FrequencyCapFromJSON))),
    };
}
exports.UpdateDealRequestFromJSONTyped = UpdateDealRequestFromJSONTyped;
function UpdateDealRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'ad_formats': (value.adFormats.map(DealAdFormats_1.DealAdFormatsToJSON)),
        'placements': (value.placements.map(DealPlacements_1.DealPlacementsToJSON)),
        'price_floor_micro_amount': value.priceFloorMicroAmount,
        'budget_micro_amount': value.budgetMicroAmount,
        'currency_code': value.currencyCode,
        'start_time': (value.startTime.toISOString()),
        'end_time': (value.endTime.toISOString()),
        'targets': (0, Targets_1.TargetsToJSON)(value.targets),
        'category': value.category,
        'frequency_caps': value.frequencyCaps === undefined ? undefined : (Array.from(value.frequencyCaps).map(FrequencyCap_1.FrequencyCapToJSON)),
    };
}
exports.UpdateDealRequestToJSON = UpdateDealRequestToJSON;
